import { UserStore } from "./UserStore";
import { createContext, useContext } from "react";
import CommonStore from "./CommonStore";
import FiltersStore from "./FiltersStore";
import { GlobalViewStore } from "./GlobalViewStore";
import { LaneViewStore } from "./LaneViewStore";
import { RouteViewStore } from "./RouteViewStore";
import { ShipmentViewStore } from "./ShipmentViewStore";
import { ThorEventViewStore } from "./ThorEventStore";
import { CustomerStore } from "./CustomerStore";
import IdentityStore from "./IdentityStore";
import { GroupStore } from "./GroupStore";

interface Store {
    filtersStore: FiltersStore;
    laneStore: LaneViewStore;
    commonStore: CommonStore;
    globalViewStore: GlobalViewStore;
    routeViewStore: RouteViewStore;
    shipmentViewStore: ShipmentViewStore;
    thorEventViewStore: ThorEventViewStore;
    userStore: UserStore;
    customerStore: CustomerStore;
    identityStore: IdentityStore;
    groupStore: GroupStore;
}

const identityStore = new IdentityStore();
const filtersStore = new FiltersStore(identityStore);

export const store: Store = {
    filtersStore: filtersStore,
    laneStore: new LaneViewStore(),
    commonStore: new CommonStore(),
    globalViewStore: new GlobalViewStore(filtersStore, identityStore),
    routeViewStore: new RouteViewStore(),
    shipmentViewStore: new ShipmentViewStore(),
    thorEventViewStore: new ThorEventViewStore(),
    userStore: new UserStore(),
    customerStore: new CustomerStore(),
    identityStore: identityStore,
    groupStore: new GroupStore(identityStore),
};

export const StoreContext = createContext(store);

export function useStore() {
    return useContext(StoreContext);
}
